var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 7.2H21.6V22.8C21.6 23.1183 21.4736 23.4235 21.2485 23.6485C21.0235 23.8736 20.7183 24 20.4 24H3.6C3.28174 24 2.97652 23.8736 2.75147 23.6485C2.52643 23.4235 2.4 23.1183 2.4 22.8V7.2ZM6 3.6V1.2C6 0.88174 6.12643 0.576515 6.35147 0.351472C6.57652 0.126428 6.88174 0 7.2 0H16.8C17.1183 0 17.4235 0.126428 17.6485 0.351472C17.8736 0.576515 18 0.88174 18 1.2V3.6H24V6H0V3.6H6ZM8.4 2.4V3.6H15.6V2.4H8.4ZM8.4 12V19.2H10.8V12H8.4ZM13.2 12V19.2H15.6V12H13.2Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete-icon.ee4a9d24641f39f080f02c4317351d20.svg";
export { ForwardRef as ReactComponent };